import { heapEvent } from '@equipmentshare/heaper'
import AddPartModal from './add-part-modal/add-part-modal'
import EditPartModal from './edit-part-modal/edit-part-modal'
import MergePartsModal from './merge-parts-modal/merge-parts-modal'
import { Part } from '../../../../../graphql'

export function getAddModal( onSuccess: () => void ) {
	return {
		component: AddPartModal,
		label: 'Add Product',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Add Part Modal - Click - X button', {} ),
	}
}

export function getEditModal( part: Part, onMerge: ( part: Part ) => void, onSuccess?: () => void ) {
	const standardPrice = part.standardPrice ? new Intl.NumberFormat(
		'en-US',
		{
			style: 'decimal',
			currency: part.standardPrice.currencyCode,
			maximumFractionDigits: 4,
			minimumFractionDigits: 2,
			useGrouping: false,
		}
	).format( part.standardPrice.amount ) : ''

	const msrp = part.msrp ? new Intl.NumberFormat(
		'en-US',
		{
			style: 'decimal',
			currency: 'USD',
			maximumFractionDigits: 4,
			minimumFractionDigits: 2,
			useGrouping: false,
		}
	).format( part.msrp ) : ''

	const productClass = part.productClass

	return {
		component: EditPartModal,
		componentProps: { onMerge, part },
		formData: {
			partId: part.id,
			provider: part.provider,
			partNumber: part.partNumber,
			description: part.partClass.description,
			upc: part.upc,
			standardPrice,
			msrp,
			productClass,
			isBulk: !!productClass,
		},
		label: 'Edit Product',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Edit Part Modal - Click - X button', {} ),
	}
}

export function getMergeModal( part: Part, onSuccess: () => void ) {
	return {
		component: MergePartsModal,
		formData: { part },
		label: 'Merge Products',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Merge Parts Modal - Click - X button', {} ),
	}
}
